import { render } from "./UploadFileField.vue?vue&type=template&id=22637b99&scoped=true&ts=true"
import script from "./UploadFileField.vue?vue&type=script&lang=ts"
export * from "./UploadFileField.vue?vue&type=script&lang=ts"

import "./UploadFileField.vue?vue&type=style&index=0&id=22637b99&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22637b99"]])

export default __exports__